import { deleteApi, postApi } from "@/utils/http";

// 获取抖音列表
export async function getCommentVideoApi(data: any): Promise<any> {
  return postApi(`/api/v1/crm/tools`, data);
}

//获取评论的一级列表
export async function getCommentListApi(data: any): Promise<any> {
  return postApi(`/api/v1/crm/tools/list`, data);
}
// 获取二级评论列表
export async function getChildListApi(data: any): Promise<any> {
  return postApi(`/api/v1/crm/tools/list/detail`, data);
}
// 批量评论作品
export async function postCommentApi(data: any): Promise<any> {
  return postApi(`/api/v1/crm/tools/batch`, data);
}
//删除评论
export async function deleteCommentApi(data: any): Promise<any> {
  return deleteApi(`/api/v1/crm/tools`, {}, data);
}
